import { useReportsAppData } from '@modules/reports/hooks/use-reports-app-data'
import * as React from 'react'
import { CustomReactSelectOption } from '@components/custom-react-select'

interface Params {
  withAllOption?: boolean
}

export const useGroupedSources = ({ withAllOption }: Params = {}): CustomReactSelectOption[] => {
  const { sources } = useReportsAppData()

  const sourceList = (sources || [])
    .filter(row => row.name)
    .map(source => ({
      label: source.name,
      value: source.id,
    }))

  return React.useMemo(
    () => [...(withAllOption ? [{ label: 'Wszystkie', value: null }] : []), ...sourceList],
    [sourceList],
  )
}
